// CRC-32C (Castagnoli, polynomial 0x82F63B78 reflected): the checksum a bucket that doesn't check
// SHA-256 reports for every object, multipart ones too (#73). Plain TypeScript, a table at a time,
// so a file can be summed as it streams: crc32c(chunk, crc32c(earlier)) is crc32c(earlier + chunk).

const TABLE = (() => {
  const t = new Uint32Array(256);
  for (let n = 0; n < 256; n++) {
    let c = n;
    for (let k = 0; k < 8; k++) c = c & 1 ? 0x82f63b78 ^ (c >>> 1) : c >>> 1;
    t[n] = c >>> 0;
  }
  return t;
})();

/** The CRC-32C of `bytes`, carried on from `crc` (a running sum's last answer), as an unsigned int. */
export function crc32c(bytes: Uint8Array, crc = 0): number {
  let c = ~crc >>> 0;
  for (let i = 0; i < bytes.length; i++) c = TABLE[(c ^ bytes[i]!) & 0xff]! ^ (c >>> 8);
  return ~c >>> 0;
}

/** A CRC-32C as a bucket writes it: its four bytes, big-endian, in base64 ("AAAAAA=="). */
export function crc32cBase64(crc: number): string {
  const b = new Uint8Array([crc >>> 24, (crc >>> 16) & 0xff, (crc >>> 8) & 0xff, crc & 0xff]);
  let s = '';
  for (const x of b) s += String.fromCharCode(x);
  return btoa(s);
}
